import type { BrandResponse } from "@/api/inbound_po_line.tsx"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"

interface ShortLineAnswerProps {
  brand_response: BrandResponse | null
  saving: boolean
  onAnswer: (response: BrandResponse | null) => void
  className?: string
}

/**
 * The brand's answer to a PO line a distributor or retailer counted short: agree it shorted the
 * line, or say it shipped in full (the receiving error to dispute). Undo clears the answer.
 */
export function ShortLineAnswer({ brand_response, saving, onAnswer, className }: ShortLineAnswerProps) {
  if (brand_response) {
    return (
      <div class={`flex items-center gap-2 text-sm ${className ?? ""}`}>
        <Badge variant={brand_response === "shipped_in_full" ? "amber" : "slate"}>
          {brand_response === "shipped_in_full" ? "Shipped in full" : "Confirmed short"}
        </Badge>
        <button type="button" class="text-xs text-slate-500 hover:underline" disabled={saving} onClick={() => onAnswer(null)}>
          Undo
        </button>
      </div>
    )
  }
  return (
    <div class={`flex gap-2 ${className ?? ""}`}>
      <Button size="sm" variant="outline" disabled={saving} onClick={() => onAnswer("confirmed_short")}>
        We shorted it
      </Button>
      <Button size="sm" variant="outline" disabled={saving} onClick={() => onAnswer("shipped_in_full")}>
        We shipped in full
      </Button>
    </div>
  )
}
